// メタ系エントリ（__label__, __button__, __varlist__, __funclist__ 等）
type MetaBlockEntry = { type: `__${string}`; visible: boolean; label?: never };

// 通常ブロック（label必須）
type NormalBlockEntry = { type: string; visible: boolean; label: string };

export type BlockEntry = MetaBlockEntry | NormalBlockEntry;

export interface CategoryDef {
    name: string;
    nameEn: string;
    color: string;
    blocks: BlockEntry[];
}

export const CATEGORIES = {
    schoomy: {
        name: 'スクーミーボード',
        nameEn: 'Schoomy Board',
        color: '#FFB300',
        blocks: [
            { type: 'schoomy_board', visible: true, label: 'スクーミーボード' },
            { type: 'setup', visible: true, label: 'セットアップ' },
        ],
    },
    serial: {
        name: 'モニタリング',
        nameEn: 'Monitoring',
        color: '#28CBC1',
        blocks: [
            { type: 'monitor_print', visible: true, label: 'シリアルモニター' },
            { type: 'monitor_graph', visible: true, label: 'グラフモニター' },
            { type: 'monitor_bluetooth', visible: true, label: 'シリアルモニター bluetooth' },
        ],
    },
    action: {
        name: 'アクション',
        nameEn: 'Action',
        color: '#FF6D00',
        blocks: [
            { type: '__label__光る', visible: true },
            { type: 'led', visible: true, label: 'LED' },
            { type: 'rgb_led', visible: true, label: 'フルカラーLED' },
            { type: 'led_bar', visible: true, label: 'LEDバー' },
            { type: '__label__鳴る', visible: true },
            { type: 'speaker', visible: true, label: 'スピーカー' },
            { type: '__label__動く', visible: true },
            { type: 'usb_a', visible: true, label: 'USB タイプA' },
            { type: 'vibration_motor', visible: true, label: '振動モーター' },
            { type: 'propeller', visible: true, label: 'プロペラ' },
            { type: 'servo_180', visible: true, label: 'サーボモーター 180度角度' },
            { type: 'tt_motor', visible: true, label: 'TTモーター' },
            { type: 'pump', visible: true, label: 'ポンプ' },
            { type: '__label__赤外線通信', visible: true },
            { type: 'ir_receiver', visible: true, label: '赤外線受信' },
            { type: 'ir_learner', visible: true, label: '赤外線受信 学習' },
            { type: 'ir_transmitter', visible: true, label: '赤外線送信' },
        ],
    },
    sensing: {
        name: 'センシング',
        nameEn: 'Sensing',
        color: '#FFA500',
        blocks: [
            { type: '__label__デジタル', visible: true },
            { type: 'touch', visible: true, label: 'タッチセンサー' },
            { type: 'interrupter', visible: true, label: '通過センサー' },
            { type: 'presence', visible: true, label: '人感センサー' },
            { type: 'water_flow', visible: true, label: '水流センサー' },
            { type: 'water_flow_measurement', visible: true, label: '水流センサー 流量計測' },
            { type: '__label__アナログ', visible: true },
            { type: 'distance', visible: true, label: '距離センサー' },
            { type: 'temperature', visible: true, label: '温度センサー' },
            { type: 'brightness', visible: true, label: '明るさセンサー' },
            { type: 'accelerometer', visible: true, label: '加速度センサー 加速度' },
            { type: 'accelerometer_angle', visible: true, label: '加速度センサー 角度' },
            { type: 'magnetic', visible: true, label: '磁気センサー' },
            { type: 'sound', visible: true, label: '音センサー' },
            { type: 'soil_moisture', visible: true, label: '土壌水分センサー' },
            { type: 'soil_moisture_c', visible: true, label: '土壌水分センサー 手動補正' },
            { type: 'pressure', visible: true, label: '圧力センサー' },
            { type: 'flex', visible: true, label: '曲げセンサー' },
            { type: 'water_temperature', visible: true, label: '水温センサー' },
            { type: 'barometric_pressure', visible: true, label: '気圧センサー' },
            { type: 'humidity', visible: true, label: '湿度センサー' },
            { type: 'rain', visible: true, label: '雨センサー' },
            { type: 'alcohol', visible: true, label: 'アルコールセンサー' },
            { type: 'ammonia', visible: true, label: 'アンモニアセンサー' },
            { type: '__label__汎用', visible: true },
            { type: 'general_digital', visible: true, label: 'デジタルリード' },
            { type: 'general_analog', visible: true, label: 'アナログリード' },
        ],
    },
    switch: {
        name: 'スイッチ',
        nameEn: 'Switch',
        color: '#009900',
        blocks: [
            { type: '__label__オン／オフ', visible: true },
            { type: 'switch', visible: true, label: 'スイッチ' },
            { type: 'switch_slide', visible: true, label: 'スライドスイッチ' },
            { type: 'switch_vibration', visible: true, label: '振動スイッチ' },
            { type: '__label__段階', visible: true },
            { type: 'switch_toggle', visible: true, label: 'トグルスイッチ' },
            { type: 'fader', visible: true, label: 'フェーダー' },
        ],
    },
    gps: {
        name: 'GPS',
        nameEn: 'GPS',
        color: '#0288D1',
        blocks: [
            { type: 'gps_location', visible: true, label: 'GPS 現在地' },
            { type: 'gps_distance', visible: true, label: 'GPS 距離' },
            { type: 'gps_speed', visible: true, label: 'GPS 速度' },
            { type: 'gps_datetime', visible: true, label: 'GPS 日時' },
        ],
    },
    display: {
        name: 'ディスプレイ',
        nameEn: 'Display',
        color: '#d80000',
        blocks: [
            { type: 'seven_seg_number', visible: true, label: '7SEG 数値' },
            { type: 'seven_seg_string', visible: true, label: '7SEG 文字' },
            { type: 'oled_print', visible: true, label: 'OLED' },
            { type: 'oled_bar', visible: true, label: 'OLED メーター' },
            { type: 'oled_clear', visible: true, label: 'OLED クリア' },
        ],
    },
    file: {
        name: 'ファイル',
        nameEn: 'File',
        color: '#78909C',
        blocks: [
            { type: 'sdcard_write', visible: true, label: 'SDカード' },
            { type: 'sdcard_clear', visible: true, label: 'SDカード クリア' },
        ],
    },
    control: {
        name: '制御',
        nameEn: 'Control',
        color: '#0f51b4',
        blocks: [
            { type: 'delay', visible: true, label: 'DELAY' },
            { type: 'millis', visible: true, label: 'MILLIS' },
            { type: '__label__条件', visible: true },
            { type: 'if', visible: true, label: 'IF' },
            { type: '__label__くりかえし', visible: true },
            { type: 'for', visible: true, label: 'FOR' },
            { type: 'for_var', visible: true, label: 'FOR 変数' },
            { type: 'while', visible: true, label: 'WHILE' },
            { type: 'while_time', visible: true, label: 'WHILE 時間' },
            { type: 'break', visible: true, label: 'BREAK' },
            { type: 'continue', visible: true, label: 'CONTINUE' },
        ],
    },
    operator: {
        name: '演算',
        nameEn: 'Operator',
        color: '#02bcdd',
        blocks: [
            { type: 'on_off', visible: true, label: 'オン／オフ' },
            { type: 'analog_max', visible: true, label: '最大値' },
            { type: '__label__比較', visible: true },
            { type: 'comparison_number', visible: true, label: '比較 数値' },
            { type: 'comparison_string', visible: true, label: '比較 文字' },
            { type: '__label__論理', visible: true },
            { type: 'logical', visible: true, label: '論理' },
            { type: 'logical_not', visible: true, label: '論理否定' },
            { type: '__label__計算', visible: true },
            { type: 'arithmetic', visible: true, label: '計算' },
            { type: 'math_abs', visible: true, label: 'ABS' },
            { type: 'math_stddev', visible: true, label: 'STDEV' },
            { type: 'math_round', visible: true, label: 'ROUND' },
            { type: 'math_random', visible: true, label: 'RANDOM' },
            { type: 'math_map', visible: true, label: 'MAP' },
        ],
    },
    variable: {
        name: '変数',
        nameEn: 'Variable',
        color: '#FF1BAC',
        blocks: [
            { type: '__button__CREATE_VARIABLE__変数の管理', visible: true },
            { type: '__label__数値', visible: true },
            { type: 'var_set_number', visible: true, label: '変数セット 数値' },
            { type: 'var_increment_number', visible: true, label: '変数セット 数値を増やす' },
            { type: '__varlist_float__', visible: true },
            { type: 'var_get_number', visible: false, label: '変数 数値' },
            { type: '__label__文字列', visible: true },
            { type: 'var_set_string', visible: true, label: '変数セット 文字列' },
            { type: '__varlist_string__', visible: true },
            { type: 'var_get_string', visible: false, label: '変数 文字列' },
            { type: '__label__真偽', visible: true },
            { type: 'var_set_bool', visible: true, label: '変数セット 真偽' },
            { type: '__varlist_bool__', visible: true },
            { type: 'var_get_bool', visible: false, label: '変数 真偽' },
        ],
    },
    func: {
        name: '関数',
        nameEn: 'Function',
        color: '#71c200',
        blocks: [
            { type: '__button__CREATE_FUNCTION__関数の管理', visible: true },
            { type: '__funclist__', visible: true },
            { type: 'func_call', visible: false, label: '関数 呼び出し' },
            { type: 'func', visible: false, label: '関数' },
            { type: 'func_return', visible: false, label: '関数 戻り' },
        ],
    },
    bluetooth: { name: 'Bluetooth', nameEn: 'Bluetooth', color: '#1565C0', blocks: [] },
    network: { name: 'ネットワーク', nameEn: 'Network', color: '#bd0000', blocks: [] },
    api: { name: 'API', nameEn: 'API', color: '#212121', blocks: [] },
} as const satisfies Record<string, CategoryDef>;

export const CATEGORY_GROUPS: { label: string; ids: CategoryId[] }[] = [
    { label: '', ids: ['schoomy', 'serial'] },
    { label: 'SENSOR & CONNECTOR', ids: ['action', 'sensing', 'switch', 'gps', 'display', 'file'] },
    { label: 'LOGIC', ids: ['control', 'operator'] },
    { label: 'DATA', ids: ['variable'] },
    { label: 'FUNCTION', ids: ['func'] },
];

export type CategoryId = keyof typeof CATEGORIES;

export type BlockType = Extract<
    { [K in keyof typeof CATEGORIES]: (typeof CATEGORIES)[K]['blocks'][number] }[keyof typeof CATEGORIES],
    { label: string }
>['type'];

export const BLOCK_LABEL_MAP = Object.fromEntries(
    (Object.values(CATEGORIES) as CategoryDef[])
        .flatMap((cat) => cat.blocks)
        .filter((b): b is NormalBlockEntry => 'label' in b)
        .map((b) => [b.type, b.label]),
) as Record<BlockType, string>;

export function getBlockLabel(type: string): string {
    return BLOCK_LABEL_MAP[type as BlockType] ?? type;
}
